import { removeStorageObject, setStorageObject } from '../utils/storage-manager';
import { Customer } from '../models/customer';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/';

@Injectable({
  providedIn: 'root'
})
export class VerticalSelectorService {
  private selectedVertical = new Subject();

  selectedVertical$ = this.selectedVertical.asObservable();

  setVertical(customer: Customer | null): void {
    if (!customer) {
      removeStorageObject('vertical');
    } else {
      setStorageObject('vertical', customer);
    }
    this.selectedVertical.next(customer?.domain ? customer.domain : null);
  }
}
